// extracted by mini-css-extract-plugin
export default {"__invalid":"styles-module--__invalid--PQwh2"};